import React from "react";
import HeroLayout from "../components/HeroLayout";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Topstatusbar from "../components/Topstatusbar";
import About_home from "../components/About_home";
import Features from "../components/Features";
import Team from "../components/Team";
import Testimonials from "../components/Testimonials";
import VideoSection from "../components/VideoSection";
import Partners from "../components/Partners";
import Contact from "../components/Contact";
import Blog from "../components/Blog";
import Socail_banner from "../components/Socail_banner";

function Home() {
  return (
    <>
    <HeroLayout>
      <Hero />
    </HeroLayout>
      <Topstatusbar />
      <About_home />
      <Services />
      <Features />
      <Team />
      <Testimonials />
      <VideoSection />
      <Partners />
      <Contact />
      <Blog />
      <Socail_banner />
    </>
  );
}

export default Home;